import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../common/types';
import { emailInitials } from '../../team/emailInitials';
import { subscriptionMemberMessages as messages } from './subscriptionMemberMessages';
import styles from './SubscriptionMemberOwnerNote.module.scss';

interface SubscriptionMemberOwnerNoteProps {
  ownerEmail: string;
  workspaceName: string;
  /** f2: the plan lapsed to Free, so the note asks the member to have the owner renew. */
  isLapsed: boolean;
}

/** design: workspaces f1 / f2 .owner-note: whom to ask about the plan of this workspace. */
const SubscriptionMemberOwnerNoteComponent: React.FC<SubscriptionMemberOwnerNoteProps> = ({
  ownerEmail,
  workspaceName,
  isLapsed,
}) => {
  const intl = useIntl();
  return (
    <div className={styles.owner}>
      <div className={styles.avatar} aria-hidden="true">
        {emailInitials(ownerEmail)}
      </div>
      <div data-clarity-mask="true">
        <b>{isLapsed ? intl.formatMessage(messages.askRenew) : ownerEmail}</b>
        <small className={styles.muted}>
          {isLapsed
            ? intl.formatMessage(messages.managesBilling, { email: ownerEmail, workspace: workspaceName })
            : intl.formatMessage(messages.ownerOf, { workspace: workspaceName })}
        </small>
      </div>
    </div>
  );
};

export const SubscriptionMemberOwnerNote = TypedMemo(SubscriptionMemberOwnerNoteComponent);
